import request from '@/utils/request'
import {
  DAILY_CLOSE_HEADS_URL,
  DAILY_CLOSE_ITEMS_URL,
} from './endpoints'
import type { DailyCloseHead, DailyCloseItem, DailyCloseItemSearch, DailyClosePage, DailyCloseSearch } from './types'

/** 타입을 우회한 레거시 필드가 섞여도 RP13 계약 필드만 API로 보낸다. */
const toCommonBody = (params: DailyCloseSearch): DailyCloseSearch => ({
  ...(params.shipperCode ? { shipperCode: params.shipperCode } : {}),
  closeDateFrom: params.closeDateFrom,
  closeDateTo: params.closeDateTo,
  ...(params.warehouseName ? { warehouseName: params.warehouseName } : {}),
  ...(params.logisticsServiceType ? { logisticsServiceType: params.logisticsServiceType } : {}),
})

export const getDailyCloseHeads = (params: DailyCloseSearch): Promise<ApiResponseV2<{ items: DailyCloseHead[] }>> =>
  request.post<ApiResponseV2<{ items: DailyCloseHead[] }>, DailyCloseSearch>(DAILY_CLOSE_HEADS_URL, toCommonBody(params))

export const getDailyCloseItems = (params: DailyCloseItemSearch): Promise<ApiResponseV2<DailyClosePage<DailyCloseItem>>> => {
  const body: DailyCloseItemSearch = {
    ...toCommonBody(params),
    shipperCode: params.shipperCode,
    warehouseName: params.warehouseName,
    page: params.page,
    pageSize: params.pageSize,
  }

  return request.post<ApiResponseV2<DailyClosePage<DailyCloseItem>>, DailyCloseItemSearch>(DAILY_CLOSE_ITEMS_URL, body)
}
